export default __webpack_public_path__ + "static/media/icon_error502.ef9bc95b.svg";